import React from "react"
import { Redirect, Switch } from "react-router-dom"
import { Wrapper } from "../Components/Navigation"
import Routing from "./routes"
import HubTheme from "./hubSidebarNavigation"
import Theme from "./themeSidebarNavigation"
import TC from "../termsAndConditionsState"

export default ({
  tcManager,
  history,
}: {
  tcManager: TC
  history: object
}): JSX.Element => {
  if (!tcManager) return null

  if (history.location.pathname === "/legal")
    return (
      <Redirect
        to={
          tcManager.userHasAcceptedAllModuleTCs()
            ? TC.hubTCUrl()
            : tcManager.nextOutstandingUrl()
        }
      />
    )

  return (
    <>
      <Wrapper
        goBack={
          tcManager.userHasAcceptedAllThemeTCs()
            ? history.goBack
            : tcManager.nextOutstandingUrl
        }
      >
        {HubTheme({ history, tcManager })}
        {tcManager.nonHubThemeModules.map(({ name }) =>
          Theme({ name: "Terms and Conditions", module: name, history })
        )}
        {tcManager.linklaters.map(({ name }) =>
          Theme({ name: "Terms and Conditions", module: name, history })
        )}
      </Wrapper>
      <Switch>
        {Routing({ tcManager })}
        <Redirect to={TC.hubTCUrl()} />
      </Switch>
    </>
  )
}
